import React, {useState} from "react";
import "./ReactivityTags.scss";

import {Button} from "../../../../../components/Button";

const ReactivityTags = ({
                            title = "",
                            id = null,
                            childrens = [],
                            categoriesSelected = [],
                            suggestionCategories = [],
                            updateCategoriesSelected = ()=>{}
                        }) => {

    const [toggle, setToggle] = useState(null);

    function updateCategories(categoryId){
        let indexCat = categoriesSelected.findIndex(item => item === categoryId.toString());
        if(indexCat === -1){
            categoriesSelected.push(categoryId.toString());
        }
        else{
            categoriesSelected = categoriesSelected.filter(item => item !== categoryId.toString())
        }

        updateCategoriesSelected(categoriesSelected);
    }


    return (
        <div className="tag-moderations-qualification-medias-tags-list">
            <p className={`inaccuracy ${toggle ? "open" : ""}`} onClick={()=> setToggle(!toggle)}>
                {title}
            </p>
            <div className={"group-categories-list"}>
                {childrens.filter(item => suggestionCategories.includes(item._id.toString())).map(subCat =>{
                    let isActive = categoriesSelected.includes(subCat._id.toString());
                    return (
                        <li
                            key={subCat._id}
                            className={`category-suggestion ${isActive ? "active" : ""}`}
                            onClick={()=>updateCategories(subCat._id)}
                        >
                            {subCat.title} {!isActive ? " ?" : ""}
                        </li>
                    )
                })}
            </div>
            <div className={`group-categories-btn ${!toggle ? "categories-hidden" : ""}`}>
                {childrens.map(subCat =>(<Button
                            key={subCat._id}
                            className={`${categoriesSelected.includes(subCat._id.toString()) ? "active" : ""}`}
                            content={subCat.title}
                            onClick={()=>updateCategories(subCat._id)}
                        />
                    )
                )}
            </div>

        </div>
    )
}

export default ReactivityTags;